export var MerchandisedDataType;
(function (MerchandisedDataType) {
    MerchandisedDataType["VG"] = "VG";
    MerchandisedDataType["S"] = "S";
    MerchandisedDataType["P"] = "P";
})(MerchandisedDataType || (MerchandisedDataType = {}));
